export const mapboxToken =
  process.env.MAPBOX_TOKEN_GI || process.env.MAPBOX_TOKEN;
